import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import Link from '@components/primitives/Link'
import { classMerge } from '@components/utilities/classMerge'
import Routes from '@lib/routes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'

export default function TrustUsSection({ className }: { className?: string }) {
  return (
    <div
      className={classMerge(
        'max-w-96 space-y-7 rounded-lg border-[1.5px] border-neutral200 bg-white p-4',
        className,
      )}
    >
      <section className='space-y-4' id='why-we-started-power'>
        <span className='text-sm font-bold leading-normal text-neutral500'>
          Why We Started Power
        </span>
        <p className='text-xs leading-normal text-neutral500 antialiased'>
          We started Power when my dad was diagnosed with multiple myeloma, and
          I struggled to help him access the latest immunotherapy. Hopefully
          Power makes it simpler for you to explore promising new treatments,
          during what is probably a difficult time.
        </p>
        <div className='flex items-center' id='author-section'>
          <CloudflareImage
            alt='Bask'
            className='size-8 rounded-full'
            height={30}
            imageId='92e8d147-4bd2-42ec-2760-8c2c2ff60500'
            width={30}
          />
          <div className='flex flex-col pl-2'>
            <span className='text-xs font-semibold leading-normal text-neutral500'>
              Bask Gill
            </span>
            <span className='text-xs leading-normal text-neutral500'>
              CEO at Power
            </span>
          </div>
        </div>
      </section>
      <section id='learn-more-about-trials'>
        <span className='text-sm font-bold leading-normal text-neutral500'>
          Learn More About Trials
        </span>
        <div className='flex flex-col gap-2 pt-4'>
          <Link
            className='text-xs font-semibold leading-normal text-neutral500 underline decoration-primary100 underline-offset-2 antialiased'
            href={absoluteUrl(Routes.learningCentre.howDoClinicalTrialsWork)}
            newTab
          >
            How Do Clinical Trials Work?
          </Link>
          <Link
            className='text-xs font-semibold leading-normal text-neutral500 underline decoration-primary100 underline-offset-2 antialiased'
            href={absoluteUrl(Routes.learningCentre.areClinicalTrialsSafe)}
            newTab
          >
            Are Clinical Trials Safe?
          </Link>
          <Link
            className='text-xs font-semibold leading-normal text-neutral500 underline decoration-primary100 underline-offset-2 antialiased'
            href={absoluteUrl(
              Routes.learningCentre.whatCanIExpectDuringAClinicalTrial,
            )}
            newTab
          >
            What Can I Expect During a Clinical Trial?
          </Link>
        </div>
      </section>
    </div>
  )
}
